import { useContext } from 'react';

import { PromotionContext } from './PromotionContext';

import type { PromotionContextValue } from './types';

export function usePromotion(): PromotionContextValue {
  return useContext(PromotionContext);
}
